import React, { useState } from "react";
import CommonAccountPanelView from "presentational/account/CommonAccountPanelView";
import LoadingModalView from "presentational/common/modals/LoadingModalView";
import { checkUsernameExist } from "lib/accountDuplicationChecker";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { useHistory } from "react-router-dom";
import { withStore } from "store/storeHandler";
import { withToken } from "lib/forceTokenRenewComponent";
import { getEssentialUrl } from "lib/urlQueryParser";
import Restful from "lib/restful";

const MAX_LENGTH_OF_USERNAME = config.username.maxLengthOfUsername;

function RootChangeUsername(props) {
  const { MyAccountActions, AppErrorActions, NoticeModalActions } = props;
  const { getIdTokenWT, forceRenewTokenWT } = props;
  const [username, setUsername] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const history = useHistory();

  const displayNotice = (type, callback) => {
    let content;
    switch (type) {
      case "emptyUsername":
        content = <TXT name="msg_enterNewUsername" />;
        break;
      case "usernameAlreadyExist":
        content = <TXT name="msg_usernameExist" />;
        break;
      case "success":
        content = <TXT name="msg_usernameChanged" />;
        break;
      case "tooLongUsername":
        content = (
          <TXT
            name="msg_usernameTooLong"
            input={{ characterLength: MAX_LENGTH_OF_USERNAME }}
          />
        );
        break;
      case "unavailableUsername":
        content = <TXT name="msg_unavailableUsername" />;
        break;
      case "changeError":
      default:
        content = <TXT name="msg_commonNetworkError" />;
        break;
    }
    NoticeModalActions.openModal({ content, callback });
  };

  const handleChangeSuccess = () => {
    MyAccountActions.editUsername(username);
    history.replace(getEssentialUrl({ type: "portfolio" })(username));
  };

  const handleTextChange = (type, value) => {
    switch (type) {
      case "username":
        setUsername(value);
        break;
      default:
        AppErrorActions.setSafeAppError(Error(`type error => type:"${value}"`));
        break;
    }
  };

  const handleSubmitBtnClick = async () => {
    if (!username) {
      displayNotice("emptyUsername");
      return null;
    }
    if (username.length > MAX_LENGTH_OF_USERNAME) {
      displayNotice("tooLongUsername");
      return null;
    }

    if (isLoading) return null;

    await setIsLoading(true);

    try {
      const { message } = await checkUsernameExist(username);
      if (message === "AlreadyExist") {
        setIsLoading(false);
        displayNotice("usernameAlreadyExist");
        return null;
      } else if (message === "ReservedWord") {
        setIsLoading(false);
        displayNotice("unavailableUsername");
        return null;
      }
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
      setIsLoading(false);
      displayNotice("changeError");
      return null;
    }

    const hasSucceed = await forceRenewTokenWT();
    if (!hasSucceed) {
      setIsLoading(false);
      return null;
    }

    const { idToken, hasTokenExpired } = await getIdTokenWT();
    if (hasTokenExpired) {
      setIsLoading(false);
      return null;
    }
    const data = { username };

    const { code, errInfo } = await Restful.editMyUsernameAPI({
      data,
      idToken
    });
    let modalType, callback;
    if (code === "ok") {
      modalType = "success";
      callback = handleChangeSuccess;
    } else if (code === "TooLong") {
      modalType = "tooLongUsername";
    } else if (code === "AlreadyExist") {
      modalType = "usernameAlreadyExist";
    } else {
      modalType = "changeError";
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      AppErrorActions.setSafeAppError(errObj);
    }

    setIsLoading(false);
    displayNotice(modalType, callback);
  };

  const handleCancelBtnClick = () => {
    history.goBack();
  };

  return (
    <div>
      <CommonAccountPanelView
        title={<TXT name="titlePanel_changeUsername" />}
        textElement={["username"]}
        onInputValueChange={handleTextChange}
        firstBtnText={<TXT name="btnPanel_changeUsername" />}
        onFirstBtnClick={handleSubmitBtnClick}
        modeToggleBtnText={<TXT name="btnPanelToggle_cancel" />}
        onModeToggleBtnClick={handleCancelBtnClick}
      />
      <LoadingModalView open={isLoading} />
    </div>
  );
}

export default withStore({
  dispatchMap: ["myAccount", "appError", "noticeModal"]
})(withToken(RootChangeUsername));
